module.exports = __webpack_public_path__ + "media/images/undraw/psc/chat_bot-0fba4f01d9a20d414e8e3294e7bc26b5.png";